import { render, staticRenderFns } from "./ModelList.vue?vue&type=template&id=4fce0123&scoped=true"
import script from "./ModelList.vue?vue&type=script&lang=js"
export * from "./ModelList.vue?vue&type=script&lang=js"
import style0 from "./ModelList.vue?vue&type=style&index=0&id=4fce0123&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fce0123",
  null
  
)

export default component.exports